module.exports = __webpack_public_path__ + "img/Act-to-adapt.95daa797.jpg";